import get from 'lodash/get';

export default function hasRouteComponent(route: any): boolean {
  return !!(get(route, 'indexRoute.component') || get(route, 'component'));
}
